import getAllNotifications from "./getAllNotifications";
import getLimitedNotifications from "./getLimitedNotifications";
import readAllNotifications from "./readAllNotification";
import readNotification from "./readNotification";
import hasUnreadNotifications from "./hasUnreadNotifications";

const NotificationCenter = {
  getAllNotifications,
  readAllNotifications,
  readNotification,
  getLimitedNotifications,
  hasUnreadNotifications
};

export default NotificationCenter;
